module.exports = __webpack_public_path__ + "static/logo-vertical-circle-d2f0471ab71fcfec15e9e3f878b3d9b1.svg";